module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-uploader"
  }, [(_vm.checkType === 'media_video') ? _c('div', {
    staticClass: "file-uploader__input",
    on: {
      "click": _vm.onFileuploaderClicked
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadType),
      expression: "uploadType"
    }],
    attrs: {
      "type": "radio",
      "value": "vimeo"
    },
    domProps: {
      "checked": _vm._q(_vm.uploadType, "vimeo")
    },
    on: {
      "change": function($event) {
        _vm.uploadType = "vimeo"
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vimeoLink),
      expression: "vimeoLink"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Place link to vimeo"
    },
    domProps: {
      "value": (_vm.vimeoLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vimeoLink = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkType === 'media_video') ? _c('div', {
    staticClass: "file-uploader__input",
    on: {
      "click": _vm.onFileuploaderClicked
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadType),
      expression: "uploadType"
    }],
    attrs: {
      "type": "radio",
      "value": "youtube"
    },
    domProps: {
      "checked": _vm._q(_vm.uploadType, "youtube")
    },
    on: {
      "change": function($event) {
        _vm.uploadType = "youtube"
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.youtubeLink),
      expression: "youtubeLink"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Place link to youtube"
    },
    domProps: {
      "value": (_vm.youtubeLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.youtubeLink = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkType !== 'media_video') ? _c('div', {
    staticClass: "file-uploader__input",
    on: {
      "click": _vm.onFileuploaderClicked
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadType),
      expression: "uploadType"
    }],
    attrs: {
      "type": "radio",
      "value": "url"
    },
    domProps: {
      "checked": _vm._q(_vm.uploadType, "url")
    },
    on: {
      "change": function($event) {
        _vm.uploadType = "url"
      }
    }
  }), _vm._v(" "), (_vm.pathPrefix) ? _c('SelectelUploader', {
    attrs: {
      "file-link": _vm.fileLink,
      "selectel-list": _vm.selectelList,
      "selectel-loading": _vm.selectelLoading,
      "link-status": _vm.linkStatus
    },
    on: {
      "blur": _vm.checkLink,
      "file-attached": _vm.attachFile
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "file-uploader__dropzone"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadType),
      expression: "uploadType"
    }],
    attrs: {
      "type": "radio",
      "value": "file"
    },
    domProps: {
      "checked": _vm._q(_vm.uploadType, "file")
    },
    on: {
      "change": function($event) {
        _vm.uploadType = "file"
      }
    }
  }), _vm._v(" "), (_vm.checkType !== 'media_video' || _vm.defaultFile) ? _c('Dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.fileChanged,
      "vdropzone-file-added": _vm.fileChanged
    }
  }) : _c('div', {
    staticClass: "file-uploader__multiple-dropzone"
  }, [_c('VideoQualityUploader', {
    attrs: {
      "check-type": _vm.checkType,
      "quality-array": _vm.qualityArray,
      "dropzone-options": _vm.dropzoneOptions,
      "selectel-list": _vm.selectelList,
      "selectel-loading": _vm.selectelLoading,
      "default-files": _vm.defaultFiles,
      "uploaded-files": _vm.uploadedFilesDictionary
    },
    on: {
      "content-change": _vm.onContentChange
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64caab41","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/FileUploader/Index.vue
// module id = 929
// module chunks = 0